export enum TypeElement {
    TEXT = 'TEXT',
    EMAIL = 'EMAIL',
    SELECT = 'SELECT',
    DATEPICKER = 'DATEPICKER',
    CHECKBOX = 'CHECKBOX',
    NUMBER = 'NUMBER',
    RADIO_GROUP = 'RADIO-GROUP',
    RADIO_BUTTON = 'RADIO-BUTTON',
}
